var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEyeOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.78 12.78C11.6922 13.6092 10.3676 14.0685 9 14.0909C4.54545 14.0909 2 8.99998 2 8.99998C2.79157 7.52483 3.88945 6.23601 5.22 5.21998M7.66364 4.0618C8.10167 3.95927 8.55013 3.90802 9 3.90907C13.4545 3.90907 16 8.99998 16 8.99998C15.6137 9.72264 15.153 10.403 14.6255 11.03M10.3491 10.3491C10.1743 10.5366 9.96355 10.6871 9.72937 10.7914C9.49519 10.8958 9.24239 10.9519 8.98606 10.9564C8.72972 10.9609 8.4751 10.9138 8.23739 10.8177C7.99967 10.7217 7.78373 10.5788 7.60245 10.3975C7.42116 10.2163 7.27825 10.0003 7.18223 9.76259C7.08622 9.52488 7.03906 9.27026 7.04358 9.01392C7.04811 8.75759 7.10421 8.50479 7.20856 8.27061C7.3129 8.03643 7.46334 7.82567 7.65091 7.65089",
    stroke: "#8B8987",
    strokeWidth: 1.69697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L16 16",
    stroke: "#8B8987",
    strokeWidth: 1.69697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOff);
export default __webpack_public_path__ + "static/media/icon-eye-off.9a404fd9bea40ceb8e1ac7d052232bd4.svg";
export { ForwardRef as ReactComponent };